// extracted by mini-css-extract-plugin
export default {"container":"AuthBtn_container__J6mZc","complete":"AuthBtn_complete__59Zep"};